import React, { useState, useRef } from 'react';
import { Button, Row, Col, Modal, Form } from 'react-bootstrap';
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { duotone } from '@fortawesome/fontawesome-svg-core/import.macro';
import useMonitorAPIService from '../../services/monitorapiservice';
import Toastr from '../utils/toastr';
import BlockUi from 'react-block-ui';

function RecoverPassword(props) {

    const { recoverPwd } = useMonitorAPIService();
    const { t } = useTranslation();
    const [username, setUsername] = useState("");
    const [loading, setLoading] = useState(false);
    const [usernameIsEmpty] = useState(false);
    const toastrRef = useRef(null);


    const sendEmail = e => {

        setLoading(true);
        let data = {
            "tenant": window.location.host.split(".")[0],
            "tenantAlias": window.location.hostname,
            "user": username
        };
        recoverPwd(data, res => {
            setLoading(false);
            if (res.data && res.data === "OK") {
                toastrRef.current.setType("success");
                toastrRef.current.setMessage(t("recoveremailsent"));
                toastrRef.current.show();
            } else {
                toastrRef.current.setType("error");
                toastrRef.current.setMessage(t("recoveremailsenterror"));
                toastrRef.current.show();
            }
            props.toggleModal();
        })
    }

    return (
        <>
            <Modal show={props.show} onHide={props.toggleModal} size="lg">
                <BlockUi tag="div" blocking={loading} color="#009ef7" message={t("pleasewait")}>
                    <Modal.Header closeButton>
                        <Modal.Title><FontAwesomeIcon icon={duotone("key")} /> {t("recoverpwd")}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Row>
                            <Col>
                                <Form>
                                    <Form.Group className="mb-4">
                                        <Form.Group className="mb-4" controlId="fcUserName">
                                            <Form.Control type="text" value={username} onChange={e => setUsername(e.target.value)} placeholder={t("username")} isInvalid={usernameIsEmpty} />
                                            {
                                                (usernameIsEmpty) &&
                                                <Form.Text id="passwordHelpBlock" className='text-danger'>
                                                    {t("usernammeisempty")}
                                                </Form.Text>
                                            }
                                        </Form.Group>
                                    </Form.Group>
                                </Form>
                            </Col>
                        </Row>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="primary" onClick={sendEmail}>
                            <FontAwesomeIcon icon={duotone("paper-plane-top")} /> {t("send")}
                        </Button>
                    </Modal.Footer>
                </BlockUi>
            </Modal>
            <Toastr ref={toastrRef} />
        </>)


}

export default RecoverPassword